/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_XC as XC,
} from "../../runtime/index.jsx";
export function Componente_qD_113_68(e) {
  let t = (0, ReactCompiler.c)(8),
    { sedeId: n, nombre: r, className: i } = e,
    a = i === void 0 ? `` : i;
  if (!r) return null;
  let o;
  t[0] === n ? (o = t[1]) : ((o = XC(n)), (t[0] = n), (t[1] = o));
  let s = o,
    c = `inline-flex shrink-0 items-center gap-1.5 rounded-full bg-(--panel) px-2 py-0.5 text-[11px] text-(--text) ${a}`,
    l;
  t[2] === s
    ? (l = t[3])
    : ((l = s && (
        <span
          className={`h-1.5 w-1.5 shrink-0 rounded-full`}
          style={{
            background: s,
          }}
        />
      )),
      (t[2] = s),
      (t[3] = l));
  let u;
  return (
    t[4] !== r || t[5] !== c || t[6] !== l
      ? ((u = <span className={c} children={[l, r]} />),
        (t[4] = r),
        (t[5] = c),
        (t[6] = l),
        (t[7] = u))
      : (u = t[7]),
    u
  );
}
